import { render } from "./ServicePaymentConfiguration.vue?vue&type=template&id=b3baac1e&scoped=true"
import script from "./ServicePaymentConfiguration.vue?vue&type=script&lang=js"
export * from "./ServicePaymentConfiguration.vue?vue&type=script&lang=js"

import "./ServicePaymentConfiguration.vue?vue&type=style&index=0&id=b3baac1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3baac1e"]])

export default __exports__